<template>
  <div class="signup-modify">
    <!-- 导航栏 -->
    <van-nav-bar title="报名待修改" left-arrow fixed @click-left="$router.go(-1)" />

    <div class="container">
      <!-- 空状态 -->
      <div v-if="loading && list.length === 0" class="loading-container">
        <van-loading size="24px" vertical>加载中...</van-loading>
      </div>

      <div v-else-if="list.length === 0 && !loading" class="empty-container">
        <van-empty image="search" description="暂无待修改的报名" />
      </div>

      <!-- 待修改列表 -->
      <div v-else class="list-container">
        <div v-for="(item, index) in list" :key="item.id" class="modify-item" @click="handleItemClick(item)">
          <!-- 项目信息 -->
          <div class="item-header">
            <div class="project-name">{{ item.raceName || item.projectName }}</div>
          </div>

          <div class="item-content">
            <div class="info-line">
              <div class="time-info-container">
                <span class="info-label">主办方：</span>
                <span class="info-value">{{ item.subtitle || item.organizer || '--' }}</span>
              </div>
            </div>

            <div class="info-line">
              <div class="time-info-container">
                <span class="info-label">项目时间：</span>
                <span class="info-value time-info">
                  {{ formatDate(item.startTime) }}至{{ formatDate(item.endTime) }}
                </span>
              </div>

              <span class="status-box" v-if="item.status === '2'">
                <span class="status-text">信息退回待修改</span>
              </span>
            </div>

          </div>

          <!-- 分隔线 -->
          <van-divider v-if="index < list.length - 1" />
        </div>

        <!-- 移动端加载更多 -->
        <div class="mobile-load-more" v-if="!isLastPage && list.length > 0">
          <van-button type="default" @click="loadMore" :loading="loading" :disabled="loading" block>
            {{ loading ? '加载中...' : '加载更多' }}
          </van-button>
        </div>

        <!-- 移动端加载结束 -->
        <div v-if="isLastPage && list.length > 0" class="mobile-no-more">
          <p>没有更多了</p>
        </div>

        <!-- 移动端加载状态 -->
        <div v-if="loading && list.length > 0" class="mobile-loading">
          <van-loading type="spinner" color="#1989fa" />
          <p>加载中...</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import NavBar from 'vant/lib/nav-bar';
import 'vant/lib/nav-bar/style';
import Button from 'vant/lib/button';
import 'vant/lib/button/style';
import Divider from 'vant/lib/divider';
import 'vant/lib/divider/style';
import Loading from 'vant/lib/loading';
import 'vant/lib/loading/style';
import Empty from 'vant/lib/empty';
import 'vant/lib/empty/style';
import Icon from 'vant/lib/icon';
import 'vant/lib/icon/style';
import Toast from 'vant/lib/toast';
import 'vant/lib/toast/style';
import Dialog from 'vant/lib/dialog';
import 'vant/lib/dialog/style';

Vue.use(NavBar);
Vue.use(Button);
Vue.use(Divider);
Vue.use(Loading);
Vue.use(Empty);
Vue.use(Icon);
Vue.use(Toast);
Vue.use(Dialog);

import { fetchListForModify } from '@/api/activity/index'

export default {
  name: 'SignupModify',
  data() {
    return {
      loading: true,
      loadingMore: false,
      list: [],
      total: 0,
      isLastPage: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10 // 移动端每页显示10条
      }
    }
  },
  computed: {
    pendingCount() {
      return this.list.length
    }
  },
  created() {
    this.getModifyList()
  },
  mounted() {
    document.title = '报名待修改'
  },
  methods: {
    // 格式化日期（只显示年月日）
    formatDate(dateTime) {
      if (!dateTime) return '--'
      // 处理带有时分秒的日期
      return dateTime.split(' ')[0]
    },

    // 格式化日期时间
    formatDateTime(dateTime) {
      if (!dateTime) return '--'
      return dateTime
    },

    // 获取待修改列表
    async getModifyList() {
      this.loading = true
      try {
        const response = await fetchListForModify(this.queryParams)

        console.log('接口返回数据:', response)

        if (response.code === 200) {
          // 处理返回的数据格式
          let dataList = []
          let totalCount = 0

          // 不同可能的数据结构
          if (response.data && Array.isArray(response.data.rows)) {
            dataList = response.data.rows
            totalCount = response.data.total || 0
          } else if (Array.isArray(response.rows)) {
            dataList = response.rows
            totalCount = response.total || 0
          } else if (Array.isArray(response.data)) {
            dataList = response.data
            totalCount = response.total || dataList.length
          } else if (Array.isArray(response)) {
            dataList = response
            totalCount = dataList.length
          }

          // 过滤出状态为"2"
          const filteredList = dataList.filter(item => item.status === '2')

          // 计算是否为最后一页
          const currentPageDataCount = filteredList.length
          const totalLoaded = (this.queryParams.pageNum - 1) * this.queryParams.pageSize + currentPageDataCount
          this.isLastPage = totalLoaded >= totalCount

          // 如果是第一页，直接设置数据；
          if (this.queryParams.pageNum === 1) {
            this.list = filteredList
            this.total = totalCount

            // 如果没有状态为2的数据，显示空状态
            // if (filteredList.length === 0) {
            //   Toast.fail('暂无待修改的报名信息')
            // }
          } else {
            // 追加数据
            this.list = [...this.list, ...filteredList]
          }

        } else {
          Toast.fail(response.msg || '获取列表失败')
          this.list = []
          this.total = 0
          this.isLastPage = true
        }
      } catch (error) {
        console.error('获取待修改列表失败:', error)
        Toast.fail('网络错误，请重试')
        this.list = []
        this.total = 0
        this.isLastPage = true
      } finally {
        this.loading = false
        this.loadingMore = false
      }
    },

    // 加载更多
    loadMore() {
      if (this.isLastPage || this.loading || this.loadingMore) {
        return
      }

      this.loadingMore = true
      this.queryParams.pageNum++
      this.getModifyList()
    },

    // 点击列表项
    handleItemClick(item) {
      console.log('点击项目:', item)
      this.$router.push({
        name: 'signup-form',
        query: {
          id: item.id,
          activityId: item.activityId,
          status: item.status,
          name: 'modify' // 标识是修改页面
        }
      })
    },

    // 下拉刷新
    async onRefresh() {
      this.queryParams.pageNum = 1
      await this.getModifyList()
    }
  }
}
</script>

<style lang="scss" scoped>
.signup-modify {
  min-height: 100vh;
  background-color: #f5f5f5;

  .container {
    padding-top: 46px; // 导航栏高度
    padding-bottom: 20px;
  }

  .loading-container,
  .empty-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 60vh;
  }

  .list-container {
    padding: 12px;

    .modify-item {
      background: #fff;
      border-radius: 8px;
      padding: 16px;
      margin-bottom: 12px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
      cursor: pointer;

      &:active {
        background-color: #fafafa;
      }

      .item-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 12px;

        .project-name {
          flex: 1;
          font-size: 18px;
          font-weight: 600;
          color: #333;
          line-height: 1.4;
        }
      }

      .item-content {
        .info-line {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 8px;
          font-size: 14px;
          line-height: 1.5;
          min-height: 24px;

          &:last-child {
            margin-bottom: 0;
          }

          .time-info-container {
            display: flex;
            align-items: center;
            flex: 1;
            min-width: 0; // 防止flex溢出

            .info-label {
              color: #999;
              min-width: 70px;
              flex-shrink: 0;
            }

            .info-value {
              flex: 1;
              color: #666;
              word-break: break-all;
              min-width: 0; // 防止文字溢出
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;

              &.reject-reason {
                color: #ee0a24;
                background-color: #fff2f2;
                padding: 4px 8px;
                border-radius: 4px;
                border-left: 3px solid #ee0a24;
                white-space: normal; // 允许换行
                word-break: break-word;
              }
            }
          }

          .status-box {
            display: flex;
            align-items: center;
            white-space: nowrap;
            margin-left: 8px;
            padding: 2px 0;
            background-color: #fff2f2;
            border-radius: 4px;
            flex-shrink: 0; // 防止被压缩

            .status-text {
              font-size: 12px;
              color: #ee0a24;
              font-weight: 500;
              margin-right: 4px;
            }
          }
        }
      }
    }

    // 移动端加载更多
    .mobile-load-more {
      margin-top: 15px;
      text-align: center;

      .van-button {
        width: 100%;
        border-radius: 20px;
        background-color: #fff;
        border-color: #e8e8e8;
        color: #333;

        &:active {
          background-color: #f5f5f5;
        }
      }
    }

    // 移动端加载结束
    .mobile-no-more {
      text-align: center;
      padding: 20px;
      color: #909399;
      font-size: 14px;
    }

    // 移动端加载状态
    .mobile-loading {
      text-align: center;
      padding: 20px;

      .van-loading {
        margin: 0 auto;
      }

      p {
        margin-top: 10px;
        color: #909399;
        font-size: 14px;
      }
    }
  }

  // 导航栏样式
  ::v-deep .van-nav-bar {
    background: #fff;
    border-bottom: 1px solid #f0f0f0;

    .van-nav-bar__title {
      font-size: 16px;
      font-weight: 600;
      color: #333;
    }

    .van-nav-bar__arrow {
      color: #333;
      font-size: 18px;
    }
  }

  // 空状态样式
  ::v-deep .van-empty {
    padding: 40px 0;

    .van-empty__image {
      width: 100px;
      height: 100px;
    }

    .van-empty__description {
      margin-top: 12px;
      color: #999;
      font-size: 14px;
    }
  }

  // 加载样式
  ::v-deep .van-loading {
    .van-loading__text {
      margin-top: 8px;
      color: #999;
      font-size: 14px;
    }
  }

  // 分割线样式
  ::v-deep .van-divider {
    margin: 16px 0 0 0;
    border-color: #f0f0f0;
  }
}
</style>